import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import BottomSheet from '../../../../Components/Ui/BottomSheet';
import { Button } from '../../../../Components/MUIs';
import TimePicker from './TimePicker';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';

export default function ExtendBottomSheet({ SaveLogic1 }) {
  const dispatch = useDispatch();
  const { extendData, approvalLine } = useSelector((state) => state.permit);
  const {
    intermediateApprovers: _legacyIntermediateApprovers,
    finalApprover: _legacyFinalApprover,
    ...baseExtendData
  } = extendData;
  const { depHeads, safetyManager } = approvalLine;
  const [selectedEndDate, setSelectedEndDate] = useState(
    dayjs(extendData.workEndDate)
  );

  const handleEndTimeSelect = (formatted, updated) => {
    let hour = parseInt(updated.hour);
    const minute = parseInt(updated.minute);
    const period = updated.period;

    if (period === 'PM' && hour < 12) {
      hour += 12;
    } else if (period === 'AM' && hour === 12) {
      hour = 0;
    }

    setSelectedEndDate((prev) => prev.hour(hour).minute(minute).second(0));
  };

  const handleConfirm = async () => {
    const originalEnd = dayjs(extendData.workEndDate);
    const diffMinutes = selectedEndDate.diff(originalEnd, 'minute');

    if (diffMinutes <= 0) {
      dispatch(
        showSnackbar({
          message: '종료 시간은 기존보다 이후여야 합니다.',
          type: 'warning',
        })
      );
      return;
    }
    if (diffMinutes > 240) {
      dispatch(
        showSnackbar({
          message: '연장은 최대 4시간까지 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }
    const formattedDate = selectedEndDate.format('YYYY-MM-DD HH:mm');
    const updatedData = {
      ...baseExtendData,
      workEndDate: formattedDate,
      smId: safetyManager.smId,
      depHeads,
      safetyManager,
    };
    dispatch(PermitActions.setExtendData(updatedData));
    dispatch(BottomSheetActions.CloseBottomSheet());
    await SaveLogic1(updatedData);
  };

  return (
    <BottomSheet
      isHeaderChildren
      headerChildren={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>
            연장 신청
          </Typography>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ color: '#918A8A', ml: 1, mb: 2 }}>
          종료 시간을 선택해주세요.
        </Typography>
        <TimePicker
          value={{
            hour: selectedEndDate.format('hh'),
            minute: selectedEndDate.format('mm'),
            period: selectedEndDate.hour() >= 12 ? 'PM' : 'AM',
          }}
          onChange={handleEndTimeSelect}
        />
        <Box p={2}>
          <Button
            name="연장 신청 완료"
            onClick={handleConfirm}
            sx={{
              width: '100%',
              height: 48,
              borderRadius: '8px',
              backgroundColor: '#57B84D',
              color: '#fff',
            }}
          />
        </Box>
      </Box>
    </BottomSheet>
  );
}
